module.exports = __webpack_public_path__ + "static/media/banner-ifc-1.637dfbb7.jpg";